
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
<mat-tab-group #tabGroup>
<mat-tab class="h-100 scrollable" label="Terms and Conditions">
    <div class="scrollable h-100">
        <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" [(ngModel)]="terms"></angular-editor>
        <div class="w-100 d-flex justify-content-end"><button class="m-3" mat-raised-button color="primary" (click)="saveTerms(terms)">Save</button></div>
    </div>
</mat-tab>
<mat-tab class="h-100 scrollable" label="Privacy Policy">
  <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" [(ngModel)]="privacy"></angular-editor>
  <div class="w-100 d-flex justify-content-end"><button class="m-3" mat-raised-button color="primary" (click)="savePrivacyPolicy(privacy)">Save</button></div>
</mat-tab>
<mat-tab class="h-100 scrollable" label="Consent">
  <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" [(ngModel)]="consent"></angular-editor>
  <div class="w-100 d-flex justify-content-end"><button class="m-3" mat-raised-button color="primary" (click)="saveCustomerConsent(consent)">Save</button></div>
</mat-tab>
</mat-tab-group>